"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesFromOption = exports.TAGGED_TYPES = void 0;
const effect_1 = require("effect");
const Water = __importStar(require("../../../water"));
const NAMESPACE = 'Culligan.Device.Class.Gbfc.Water';
function makeTaggedType(_tag, waterType) {
    return effect_1.Schema.transform(effect_1.Schema.Literal(_tag), effect_1.Schema.TaggedStruct(_tag, { waterType: effect_1.Schema.Literal(waterType) }), {
        strict: true,
        decode: _tag => ({ _tag, waterType }),
        encode: ({ _tag }) => _tag,
    });
}
exports.TAGGED_TYPES = {
    AmbientStill: { _tag: 'A', waterType: Water.Type.enums.AmbientStill },
    Chilled: { _tag: 'C', waterType: Water.Type.enums.Chilled },
    Sparkling: { _tag: 'S', waterType: Water.Type.enums.Sparkling },
    Hot: { _tag: 'H', waterType: Water.Type.enums.Hot },
    ExtraHot: { _tag: 'E', waterType: Water.Type.enums.ExtraHot },
    /** Mixes chilled and hot water to achieve ambient */
    Mixed: { _tag: 'M', waterType: Water.Type.enums.AmbientStill },
};
const Type = {
    AmbientStill: makeTaggedType('A', Water.Type.enums.AmbientStill).annotations({
        identifier: `${NAMESPACE}.WaterType.AmbientStill`,
    }),
    Chilled: makeTaggedType('C', Water.Type.enums.Chilled).annotations({
        identifier: `${NAMESPACE}.WaterType.Chilled`,
    }),
    Sparkling: makeTaggedType('S', Water.Type.enums.Sparkling).annotations({
        identifier: `${NAMESPACE}.WaterType.Sparkling`,
    }),
    Hot: makeTaggedType('H', Water.Type.enums.Hot).annotations({
        identifier: `${NAMESPACE}.WaterType.Hot`,
    }),
    ExtraHot: makeTaggedType('E', Water.Type.enums.ExtraHot).annotations({
        identifier: `${NAMESPACE}.WaterType.ExtraHot`,
    }),
    // Mixes chilled and hot water to achieve ambient
    Mixed: makeTaggedType('M', Water.Type.enums.AmbientStill).annotations({
        identifier: `${NAMESPACE}.WaterType.Mixed`,
    }),
};
exports.TypesFromOption = effect_1.Schema.Union(
// CA
effect_1.Schema.TemplateLiteralParser(Type.Chilled, Type.AmbientStill), 
// HC / CH (Twins)
effect_1.Schema.TemplateLiteralParser(Type.Hot, Type.Chilled), effect_1.Schema.TemplateLiteralParser(Type.Chilled, Type.Hot), 
// CHA / HCA (Twins)
effect_1.Schema.TemplateLiteralParser(Type.Chilled, Type.Hot, Type.AmbientStill), effect_1.Schema.TemplateLiteralParser(Type.Hot, Type.Chilled, Type.AmbientStill), 
// CHM / HCM (Twins)
effect_1.Schema.TemplateLiteralParser(Type.Chilled, Type.Hot, Type.Mixed), effect_1.Schema.TemplateLiteralParser(Type.Hot, Type.Chilled, Type.Mixed), 
// CHS / HCS (Twins)
effect_1.Schema.TemplateLiteralParser(Type.Chilled, Type.Hot, Type.Sparkling), effect_1.Schema.TemplateLiteralParser(Type.Hot, Type.Chilled, Type.Sparkling), 
// CAS
effect_1.Schema.TemplateLiteralParser(Type.Chilled, Type.AmbientStill, Type.Sparkling), 
// CHASE
effect_1.Schema.TemplateLiteralParser(Type.Chilled, Type.Hot, Type.AmbientStill, Type.Sparkling, Type.ExtraHot), 
// HCAS / CHAS (Twins)
effect_1.Schema.TemplateLiteralParser(Type.Hot, Type.Chilled, Type.AmbientStill, Type.Sparkling), effect_1.Schema.TemplateLiteralParser(Type.Chilled, Type.Hot, Type.AmbientStill, Type.Sparkling)).annotations({
    identifier: `${NAMESPACE}.TypesFromOption`,
    description: 'Transforms a GBFC water option string into an array of domain tagged water types',
});
//# sourceMappingURL=water.js.map